import axios from '@/libs/api.request'

/**
 * 获取系统配置
 */
export const getSysConfig = () => {
    return axios.request({
        url: '/api/admin/sysconfig/getConfig',
        method: 'post'
    })
}

/**
 * 保存公众号菜单
 */
export const saveMenu =(menu_str) => {
    const data = {
        'menu_str': menu_str
    }
    return axios.request({
        url: '/api/admin/sysconfig/saveMenuConfig',
        data,
        method: 'post'
    })
}

/**
 * 保存公众号菜单
 */
 export const saveConfig =(config_str) => {
    const data = {
        'config_str': config_str
    }
    return axios.request({
        url: '/api/admin/sysconfig/saveConfig',
        data,
        method: 'post'
    })
}